module.exports = __webpack_public_path__ + "img/swlj.71d17c1d.png";